// Only these need JS reachability — store/[slug].vue, premium/store/[slug].vue,
// premium/menu/[slug].vue, and orders/[id]/edit.vue use them in their sticky
// filter strip / cart inline :style ternaries. The rest of this z-index scale
// lives in app/assets/styles/_variables.scss as the source of truth — see
// that file for $z-filter, $z-nav-banner, $z-navbar, $z-cart-overlay.
export const Z_FILTER_FIXED = 50;
// Matches DynamicModal.vue's sitewide modal z-index — kept in step by hand,
// since DynamicModal.vue has no shared constant of its own to import from.
export const Z_MODAL = 9999;
export const Z_CART_FIXED = 8888;
export const Z_CART_BEHIND_MODAL = 5555;
